import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withLoading from '@pattern-library/with-loading';
import Footer, { Skeleton } from '@employee/footer';

const propTypes = {
    quickLinks: PropTypes.array,
    copyright: PropTypes.node,
    phoneNumber: PropTypes.string,
    serviceHours: PropTypes.object,
    suppressNav: PropTypes.bool,
    copyrightStatus: PropTypes.string,
    quickLinksStatus: PropTypes.string,
    supportStatus: PropTypes.string
};
const defaultProps = {
    copyrightStatus: 'pending',
    quickLinksStatus: 'pending',
    supportStatus: 'pending'
};

const mapStoreToProps = store => ({
    // footer
    copyright: store.footer.copyright,
    phoneNumber: store.footer.phoneNumber,
    serviceHours: store.footer.serviceHours,
    quickLinks: store.footer.quickLinks,
    // statuses
    copyrightStatus: store.footer.copyrightStatus,
    supportStatus: store.footer.supportStatus,
    quickLinksStatus: store.footer.quickLinksStatus
});

const FooterWithLoading = withLoading(Footer, Skeleton, () => null);

function FooterContainer(props) {
    const {
        quickLinks,
        phoneNumber,
        serviceHours,
        copyright,
        suppressNav,
        copyrightStatus,
        quickLinksStatus,
        supportStatus
    } = props;

    return (
        <FooterWithLoading
            status={[copyrightStatus, quickLinksStatus, supportStatus]}
            quickLinks={quickLinks}
            phoneNumber={phoneNumber}
            serviceHours={serviceHours}
            copyright={copyright}
            suppressNav={suppressNav}
        />
    );
}

FooterContainer.propTypes = propTypes;
FooterContainer.defaultProps = defaultProps;
export default connect(mapStoreToProps)(FooterContainer);
